<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <v-row class="view">
    <v-col class="col-12 pl-5 pr-5" style="position: relative">

      <v-img
          v-if="product.image_path"
          :src="'/'+product.image_path+'.175.jpg'"
          aspect-ratio="1"
          class="grey lighten-2"
      >

      </v-img>
      <v-img
          v-else
          :src="'/images/products/default.175.jpg'"
          aspect-ratio="1"
          class="grey lighten-2"
      >

      </v-img>
      <v-btn
          v-if="product.non_over_stock"
          class="ml-1 orange pa-1 caption"
          style="color: white;position: absolute;top: 0" x-small>
        !! สินค้าไม่ผลิตเพิ่ม
      </v-btn>

    </v-col>
    <v-col class="detail col-12 pl-5 pr-5">
      <!--{{ product.nickcode}}-->
      <div class="nickname">
         <span v-if="product.unit_primitive === 'CTN'"
               class="red pl-1" style="color: white">
        ยกหีบ
      </span>
        {{ product.nickname}}

      </div>
    </v-col>
    <v-col class="detail pl-5">
      <div v-if="$store.state.carts.current.id" class=" text-left stock">
          <span class="">
            <span class="currency">คลัง</span> {{$helper.number_format(product.stock_MT * product.unit_prim_rate-product.reserve_MT)}}<span
              class="unit">{{$helper.parseUnit(product.unit_primitive)}}</span>
            <br/>
            <span class="currency">ราคา</span> {{product['price_'+$store.state.carts.current.price_group]}}<span
              class="currency">บ.</span>
          </span>

      </div>
      <div v-else class="text-left stock">
         <span class="">
           คลัง {{$helper.number_format(product.stock_MT  * product.unit_prim_rate-product.reserve_MT)}}</span><br/>
        <!--<span v-if="product.stock_MT>0">MT:{{ product.stock_MT}},-->
        <!--{{ product.price_MT}}<span class="currency">บ.</span>-->
        <!--</span>-->
        <!--<br v-if="product.stock_MT>0 && product.stock_PJ>0"/>-->
        <!--<span v-if="product.stock_PJ>0">PJ:{{ product.stock_PJ}},-->
        <!--{{ product.price_PJ}}<span class="currency">บ.</span>-->
        <!--</span>-->


      </div>
    </v-col>
    <v-col class="col-12 col-md-5 text-right pr-5">
      <v-btn :class="$store.state.carts.current_item_map[product.id]?'primary':''"
             :disabled="product.non_over_stock && product.stock_MT * product.unit_prim_rate-product.reserve_MT<=0"
             @click.stop="onClickAddCart(product)">เพิ่ม
        <span v-if="$store.state.carts.current_item_map[product.id]">
              {{$store.state.carts.current_item_map[product.id].quantity}}</span>
      </v-btn>
    </v-col>
  </v-row>


</template>
<style lang="scss" scoped>
  .view {
    .col {
      padding: 6px;
    }
  }

  .detail {
    font-size: 14px;
  }

  .nickname {
    height: 40px;
    overflow-y: hidden;
  }

  .stock {
    font-size: 16px;
  }

  .unit {
    font-size: 0.7em;
  }

  .percent {
    font-size: 0.7em;
  }

  .currency {
    /*display: block;*/
    /*width: 32px;*/
    /*float: right;*/
    font-size: 0.7em;
  }

</style>

<script lang="ts">

  import {Component, Prop, Vue} from 'vue-property-decorator'
  import {Product} from '../../models/Product'

  @Component({
    components: {},
  })
  export default class ProductRowGrid extends Vue {
    @Prop() product: Product
    @Prop() onClickAddCart: Function

  }

</script>
